// utils/sortAssetsByDistance.ts
import { calculateDistance } from './distanceUtils';

const formatDistance = (distance: number): string => {
  if (distance === Infinity || isNaN(distance)) return '';
  if (distance < 1) {
    return `${Math.round(distance * 1000)}m`;
  }
  return `${distance.toFixed(1)}km`;
};

export const sortAssetsByDistance = (
  assets: any[],
  userCoords: { latitude: number; longitude: number },
  formatFunction: (asset: any) => any
): any[] => {
  return assets
    .map(asset => {
      const displayInfo = formatFunction(asset);
      const coords = displayInfo.coordinates;

      // console.log('Asset coordinates array:', coords);

      if (!coords || !Array.isArray(coords) || coords.length < 2) {
        return { ...asset, distanceFromUser: Infinity };
      }

      const assetLatitude = coords[1];
      const assetLongitude = coords[0];

      if (assetLatitude == null || assetLongitude == null) {
        return { ...asset, distanceFromUser: Infinity };
      }

      const distance = calculateDistance(
        userCoords.latitude,
        userCoords.longitude,
        assetLatitude,
        assetLongitude,
        'K'
      );

      return {
        ...asset,
        distanceFromUser: distance,
        formattedDistance: formatDistance(distance)
      };
    })
    .sort((a, b) => a.distanceFromUser - b.distanceFromUser);
};